import { AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { DatePickerComponent, DatePickerModule } from '@syncfusion/ej2-angular-calendars';
import { Subscription } from 'rxjs';
import { ClientDTO } from 'src/app/base/models/models.swagger.generated';
import { PaymentFormType } from './payment-form-type';
import { ClientService } from 'src/app/base/services/client/client.service';
import { TranslateModule } from '@ngx-translate/core';
import { ClientAutocompleteComponent } from '../../../../../base/shared/client-autocomplete/client-autocomplete.component';
import { ReactiveFormsModule } from '@angular/forms';
import { AuthService } from 'src/app/base/services/auth.service';

@Component({
    selector: 'app-payment-form',
    templateUrl: './payment-form.component.html',
    styleUrls: ['./payment-form.component.scss'],
    imports: [ReactiveFormsModule, ClientAutocompleteComponent, DatePickerModule, TranslateModule]
})
export class PaymentFormComponent implements OnInit, AfterViewInit, OnDestroy {

  @ViewChild(ClientAutocompleteComponent)
  public clientAutocomplete: ClientAutocompleteComponent;

  @ViewChild('startTime')
  public startTimePicker: DatePickerComponent;

  @ViewChild('endTime')
  public endTimePicker: DatePickerComponent;

  @Input()
  public form: PaymentFormType;

  @Output()
  public searchDTOChanged = new EventEmitter<any>();

  public isUserMode: boolean = this.authService.isUserStandardUser();

  private subscriptions = new Subscription();
  constructor(protected clientService: ClientService,
              private authService: AuthService) {
  }

  public get selectedClient(): ClientDTO {
    return this.clientService.selectedClient;
  }

  public set selectedClient(value: ClientDTO) {
    if (this.clientService.selectedClient != value) {
      this.clientService.selectedClient = value;
    }
    // Defer the event emission to avoid ExpressionChangedAfterItHasBeenCheckedError
    setTimeout(() => {
      this.onClientSelected(value);
    });
  }

  ngOnInit(): void {
    this.subscriptions.add(
      this.form.valueChanges.subscribe(() => {
        if (this.endTimePicker) {
          if (this.form.controls.startDate.value) {
            this.endTimePicker.min = this.form.controls.startDate.value;
          } else {
            this.endTimePicker.min = null;
          }
        }

        if (this.startTimePicker) {
          if (this.form.controls.endDate.value) {
            this.startTimePicker.max = this.form.controls.endDate.value;
          } else {
            this.startTimePicker.max = null;
          }
        }

        this.searchDTOChanged.emit();
      }));
  }

  ngAfterViewInit(): void {
    if (!this.selectedClient) {
      this.focusClientAutocomplete();
    }
  }

  ngOnDestroy(): void {
    this.subscriptions?.unsubscribe();
  }

  public onClientSelected(client: ClientDTO): void {
    this.searchDTOChanged.emit();
  }

  private focusClientAutocomplete(): void {
    if (this.clientAutocomplete) {
      this.clientAutocomplete.focus();
    }
  }
}
